import { Assign } from 'utility-types';
import { LectureSectionsNormalized } from '../models/lecture-section';
import { LectureSectionListSchema } from './lecture-sections';
import {
  AIOriginType,
  LecturePagesNormalized,
  SyncingStatus,
} from '../models/lecture-page';
import { LectureComponentEntities, LectureComponentsNormalized, NLectureComponent } from '../models/lecture-component';
import { LecturePageListSchema } from './lecture-pages';
import { LectureComponentListSchema } from './lecture-components';
import { SkillTaggingNormalized } from '../models/skill-tag';

export const TimelineSchema = {
  lectureSections: LectureSectionListSchema,
  lectureSubsections: LectureSectionListSchema,
  lecturePages: LecturePageListSchema,
  lectureComponents: LectureComponentListSchema,
};

export type TimelineEntities = Assign<LectureComponentEntities, {
  lectureSections: LectureSectionsNormalized,
  lectureSubsections: LectureSectionsNormalized,
  lecturePages: LecturePagesNormalized,
  lectureComponents: LectureComponentsNormalized,
  skillTaggings?: SkillTaggingNormalized,
}>;

export interface TimelineNormalizedResult {
  lectureSections: number[],
  lectureSubsections: number[],
  // TODO: add remaining items
}

interface LecturePageMetaUser {
  id: number;
  firstName: string;
  lastName: string;
  email: string;
}

interface LecturePageMetaCollection {
  id: number;
  title: string;
  creator: LecturePageMetaUser;
  lastEditor: LecturePageMetaUser;
}

interface LecturePageMetaLinkedPage {
  id: number;
  createdAt: string;
  lastEditedAt: string;
}

export interface LecturePageMetaParams {
  catalogId: string;
  lecturePageIds: number[];
}

export interface LecturePageMetaItem {
  id: number;
  aiOrigin: AIOriginType;
  hasAnyActivities: boolean;
  hasContent: boolean;
  hasDeadlines: boolean;
  hasStructuralIssues: boolean;
  structuralIssueErrorCodes: string[];
  hasTimelineIssues: boolean;
  hasMultisessionLiveEvents: boolean;
  isLinked: boolean;
  hasUpdatedLink: boolean;
  syncingStatus: SyncingStatus;
  contentManagementCollection: LecturePageMetaCollection | null;
  contentManagementLecturePage: LecturePageMetaLinkedPage | null;
}

export interface LecturePageMetaResponse {
  lecturePages: LecturePageMetaItem[];
}
